import "./StartProject.module.css";
import Header from "@/reusable_sections/Header";
import RevampInquiry from "./sections/RevampInquiry";
import CommonQuestions from "./sections/CommonQuestions";
import XaritadagiManzilimiz from "./sections/XaritadagiManzilimiz";
import Footer from "@/reusable_sections/Footer";
export default function StartProjectPage() {
  return <div>
      <Header />
      <RevampInquiry />
      <CommonQuestions />
      <XaritadagiManzilimiz />
      <Footer />
    </div>;
}